import { Alert, Container, Text } from '@mantine/core'

export const OnboardingBanner = ({
  title,
  children,
}: {
  title: string
  children: React.ReactNode
}) => {
  return (
    <Alert
      data-onboarding-banner
      color="var(--mantine-primary-color-2)"
      ta="center"
      radius={0}
      display="none"
    >
      <Container strategy="grid" size="md" px={20}>
        <Text>
          <Text span fw="bold">
            {title}
          </Text>
          <Text span mx={5}>
            —
          </Text>
          <Text span>{children}</Text>
        </Text>
      </Container>
    </Alert>
  )
}

export const PromoBanner = () => {
  return (
    <OnboardingBanner title="🎉 Limited Time Offer">
      For a limited time, new free personal accounts receive access to multiple
      workspaces and up to 3 collaborators at no additional cost. These
      promotional limits are subject to change.
    </OnboardingBanner>
  )
}
